import { useState } from "react";
import { UserNamePassword } from "../types/user.type";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import UserManagementTable from "../components/UserManagement/Table";
import UserDrawer from "../components/UserManagement/UserDrawer";
import PasswordModal from "../components/UserManagement/PasswordModal";

const EMPTY_CREDENTIALS: UserNamePassword = { username: "", password: "" };

export default function UserManagementPage() {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [openModal, setOpenModalPassword] = useState<boolean>(false);
  const [userId, setUserId] = useState<string>("");
  const [usernamePassword, setUsernamePassword] =
    useState<UserNamePassword>(EMPTY_CREDENTIALS);
  const [triggerFetch, setTriggerFetch] = useState<number>(0);

  const onOpenCreateDrawer = () => setOpenDrawer(true);

  const onOpenEditDrawer = (editedUserId: string) => {
    setOpenDrawer(true);
    setUserId(editedUserId);
  };

  const onCloseDrawer = () => {
    setOpenDrawer(false);
    setUserId("");
  };

  const onCloseModal = () => {
    setOpenModalPassword(false);
    setUsernamePassword(EMPTY_CREDENTIALS);
  };

  return (
    <>
      <Stack sx={{ padding: "8px 0" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h6">ตั้งค่าผู้ใช้</Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onOpenCreateDrawer}
          >
            สร้างผู้ใช้ใหม่
          </Button>
        </Stack>
        <UserManagementTable
          triggerFetch={triggerFetch}
          onOpenEditDrawer={onOpenEditDrawer}
          setTriggerFetch={setTriggerFetch}
        />
      </Stack>
      <UserDrawer
        userId={userId}
        open={openDrawer}
        onClose={onCloseDrawer}
        setOpenModalPassword={setOpenModalPassword}
        setUsernamePassword={setUsernamePassword}
        setTriggerFetch={setTriggerFetch}
      />
      <PasswordModal
        title="สร้างผู้ใช้งานสำเร็จ"
        username={usernamePassword.username}
        password={usernamePassword.password}
        open={openModal}
        onClose={onCloseModal}
      />
    </>
  );
}
